import React, { useEffect, useRef } from 'react';

const CustomCallUsSelector = 'call-us-selector' as any;

const ThreeCXWidget: React.FC = () => {
    const anchorRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const scriptId = 'tcx-callus-js';
        const anchorElement = anchorRef.current;
        const setValidWidgetLanguage = () => {
            document
                .querySelectorAll('call-us[lang="browser"], call-us-selector[lang="browser"]')
                .forEach((element) => element.setAttribute('lang', 'en'));
        };

        // The chat bubble lives in the widget's shadow DOM, out of reach of page CSS. A style inside it lifts the
        // bubble by --lv2-chat-offset (set while a lander button bar is pinned to the bottom of the screen).
        // The widget renders more than one #wp-live-chat-by-3CX (in nested shadow roots), so every one gets the style.
        const liftChatAboveStickyBars = () => {
            const injectIntoShadowRoots = (root: Document | ShadowRoot) => {
                Array.from(root.querySelectorAll('*')).forEach((element) => {
                    const shadowRoot = element.shadowRoot;
                    if (!shadowRoot) return;
                    if (shadowRoot.querySelector('#wp-live-chat-by-3CX') && !shadowRoot.querySelector('style[data-lv2-chat-offset]')) {
                        const style = document.createElement('style');
                        style.setAttribute('data-lv2-chat-offset', '');
                        style.textContent =
                            '#wp-live-chat-by-3CX { bottom: calc(10px + var(--lv2-chat-offset, 0px)) !important; transition: bottom 0.25s ease; }';
                        shadowRoot.appendChild(style);
                    }
                    injectIntoShadowRoots(shadowRoot);
                });
            };
            injectIntoShadowRoots(document);
        };

        // The bubble renders inside the shadow DOM after the script loads, where the body observer can't see it,
        // so keep checking for the first 15 seconds.
        let liftAttempts = 0;
        const liftTimer = window.setInterval(() => {
            liftAttempts += 1;
            liftChatAboveStickyBars();
            if (liftAttempts >= 30) window.clearInterval(liftTimer);
        }, 500);

        // 1. Inject the script if it doesn't exist
        if (!document.getElementById(scriptId)) {
            const script = document.createElement('script');
            script.id = scriptId;
            script.src = "https://downloads-global.3cx.com/downloads/livechatandtalk/v1/callus.js";
            script.defer = true;
            script.addEventListener('load', setValidWidgetLanguage);
            document.head.appendChild(script);
        }

        const observer = new MutationObserver(setValidWidgetLanguage);
        observer.observe(document.body, {
            childList: true,
            subtree: true,
            attributes: true,
            attributeFilter: ['lang'],
        });
        setValidWidgetLanguage();

        // 2. Cleanup Phase: The "Exorcism"
        return () => {
            observer.disconnect();
            window.clearInterval(liftTimer);
            // Remove the main widget
            if (anchorElement) {
                anchorElement.innerHTML = '';
            }

            // Manually kill the "Zombies" that 3CX moved to the body
            const tcxElements = ['call-us-selector', 'call-us', '#wp-live-chat-by-3CX'];
            tcxElements.forEach(selector => {
                document.querySelectorAll(selector).forEach(el => el.remove());
            });
        };
    }, []);

    return (
        <div ref={anchorRef} id="tcx-anchor">
            <CustomCallUsSelector
                lang="en"
                phonesystem-url="https://futurewise.3cx.co.uk"
                party="LiveChat404477"
                style={{ position: 'fixed', bottom: '10px', right: '10px', zIndex: 100000 }}
            />
        </div>
    );
};

export default ThreeCXWidget;
